import { useEffect } from "react";
import { INTERVIEW } from "@/lib/constants";

/**
 * Polls the interview status while the manager waits and refreshes the page as
 * soon as the candidate starts (invited -> in_progress) so the live view opens
 * automatically without a manual reload.
 */
export function StatusWatcher({
  interviewId,
  currentStatus,
}: {
  interviewId: string;
  currentStatus: string;
}) {
  useEffect(() => {
    const id = setInterval(async () => {
      try {
        const res = await fetch(`/api/interviews/${interviewId}/live`, {
          credentials: "include",
          cache: "no-store",
        });
        if (!res.ok) return;
        const data = await res.json();
        if (data.status && data.status !== currentStatus) window.location.reload();
      } catch {
        /* ignore */
      }
    }, INTERVIEW.LIVE_POLL_INTERVAL_MS);
    return () => clearInterval(id);
  }, [interviewId, currentStatus]);
  return null;
}
